export default {
  // Search Comments
  SEARCH_STRUCTURED_CONTENTS: "SEARCH_STRUCTURED_CONTENTS",
};
